module.exports = __webpack_public_path__ + "static/media/icon_refresh.de6c5276.svg";